import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListeAppelsComponent } from './components/liste-appels/liste-appels.component';
import { SoumissionsComponent } from './components/soumissions/soumissions.component';
import { CandidaturesComponent } from './components/candidatures/candidatures.component';
import { CertificatsComponent } from './components/certificats/certificats.component';
import { Liste2appelsComponent } from './liste2appels/liste2appels.component';
import { FormAppelComponent } from 'src/app/components/form-appel/form-appel.component';
import { CreateActivityComponent } from '../agenda/components/create-activity/create-activity.component';
import { DeliberationComponent } from './components/deliberation/deliberation.component';
import { AdmisComponent } from './components/admis/admis.component';
import { DashBoardSiguiComponent } from '../main-layout/components/dash-board-sigui/dash-board-sigui.component';
import { SiguiComponent } from './components/sigui/sigui.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { NonadmisComponent } from './components/nonadmis/nonadmis.component';
import { SIGUIAppelsComponent } from './components/sigui-appels/sigui-appels.component';
import { TestComponent } from './components/test/test.component';
import { NewCertificateComponent } from './components/new-certificate/new-certificate.component';
import { SiguiCertificatsComponent } from './components/sigui-certificats/sigui-certificats.component';
import { HorsiguiAppelsComponent } from './components/horsigui-appels/horsigui-appels.component';
import { CandidatureHorsParcoursComponent } from './components/candidature-hors-parcours/candidature-hors-parcours.component';
import { HorsSiguiCertificateComponent } from './components/hors-sigui-certificate/hors-sigui-certificate.component';
import { HorsiguiStatComponent } from './components/horsigui-stat/horsigui-stat.component';
import { HorsiguiAdmiComponent } from './components/horsigui-admi/horsigui-admi.component';
import { CreateWebinaireComponent } from '../application-simplify/create-webinaire/create-webinaire.component';
import { CourseraAppelsComponent } from './components/coursera-appels/coursera-appels.component';
import { CourseraStatsComponent } from './components/coursera-stats/coursera-stats.component';
import { CourseraDashboardComponent } from './components/coursera-dashboard/coursera-dashboard.component';
import { CertificateMentoratsComponent } from '../mentorat/components/certificate-mentorats/certificate-mentorats.component';
import { FormNewCertificateMentoratComponent } from '../mentorat/components/form-certificate-mentorat/form-certificate-mentorat.component';
import { CandidatureSimplifyComponent } from '../application-simplify/candidature-simplify/candidature-simplify.component';
import { StatconnectionComponent } from './components/statconnection/statconnection.component';
import { StatconnectionHPComponent } from './components/statconnection-hp/statconnection-hp.component';

const routes: Routes = [
  {
    path: '',
    component: SIGUIAppelsComponent,
  },
  {
    path: 'soumissions',
    component: SoumissionsComponent,
  },
  {
    path: 'candidature',
    component: CandidaturesComponent,
  },
  {
    path: 'candidature/:id',
    component: CandidaturesComponent,
  },
  {
    path: 'candidatureHorsParcours',
    component: CandidatureHorsParcoursComponent,
  },
  {
    path: 'editApplicationOffTrack/:id',
    component: CandidatureHorsParcoursComponent,
  },
  {
    path: 'editApplicationWebinaire/:id',
    component: CandidatureSimplifyComponent,
  },

  {
    path: 'creer-une-activite',
    component: CreateActivityComponent,
  },
  {
    path: 'listAppels',
    component: Liste2appelsComponent,
  },
  {
    path: 'certificats',
    component: CertificatsComponent,
  },
  {
    path: 'soumission/:id',
    component: FormAppelComponent,
  },
  {
    path: 'deliberation/:cohortId',
    component: DeliberationComponent,
  },
  {
    path: 'admis/:cohortId',
    component: AdmisComponent,
  },
  {
    path: 'nonadmis/:cohortId',
    component: NonadmisComponent,
  },
  {
    path: 'statistiques/:cohortId',
    component: StatisticsComponent,
  },
  { path: 'test/:cohortId', component: TestComponent },
  {
    path: 'candidatures/:cohortId',
    component: SIGUIAppelsComponent,
  },
  {
    path: 'candidaturesHS/:cohortId',
    component: HorsiguiAppelsComponent,
  },
  {
    path: 'accueil',
    component: DashBoardSiguiComponent,
  },
  {
    path: 'sigui',
    component: SIGUIAppelsComponent,
  },
  {
    path: 'newcertificate',
    component: NewCertificateComponent,
  },
  {
    path: 'hors-sigui-certificate',
    component: HorsSiguiCertificateComponent,
  },
  {
  path: 'hors-sigui-certificate/duplicate/:externalId',
  component: HorsSiguiCertificateComponent,
  },
  {
    path: 'webinaire/create',
    component: CreateWebinaireComponent,
  },
  {
    path: 'new-mentorat-certificat',
    component: FormNewCertificateMentoratComponent,
  },



  {
    path: 'sigui-certificat',
    component: SiguiCertificatsComponent,
  },
  {
    path: 'admisHS/:cohortId',
    component: HorsiguiAdmiComponent,
  },
  {
    path: 'statistiquesHS/:cohortId',
    component: HorsiguiStatComponent,
  },
  {
    path: 'candidaturesCoursera/:cohortId',
    component: CourseraAppelsComponent,
  },
  {
    path: 'statistiquesCoursera/:cohortId',
    component: CourseraStatsComponent,
  },
  {
    path: 'coursera-dashboard/:courseraCohorte',
    component: CourseraDashboardComponent,
  },
  {
    path: 'statconnection/:cohortId',
    component: StatconnectionComponent,
  },
  {
    path: 'statconnectionHP/:cohortId',
    component: StatconnectionHPComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppelsRoutingModule { }
